import { Icon } from "@blueprintjs/core"
import { SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"

export interface ISelectMenuProps {
    selectType: SELECT_TYPE
    type: string
    value: any // Данные объекта 
    hideEdit?: true
 
}
export const SelectMenu = (props: ISelectMenuProps) : JSX.Element => { 
    switch(props.selectType) {
        case SELECT_TYPE.CONTENT:
            return <div className="d-flex position-absolute top left m-0 w-100 z-index-2">
                <div className={`landing-data-panel-btn p-0 ${ !props.hideEdit ? "move" : "" }`}>
                    {
                        !props.hideEdit &&
                        <Icon icon="move" size={ 12 } className=""/>
                    }
                </div> 
            </div>   
        case SELECT_TYPE.TITLE: 
            return <div className="d-flex position-absolute top left m-0 w-100"> 
                {
                    !props.hideEdit && <> 
                        <div className={`landing-data-panel-btn p-0 ${ !props.hideEdit ? "move" : "" }`} >
                            <Icon icon="move" size={ 12 } className=""/>
                        </div> 
                    </>
                }
                
            </div>    
        case SELECT_TYPE.FLOAT: 
        default: 
            return <div className="d-flex position-absolute top left m-0 w-100">
                
                {
                    !props.hideEdit && <>
                        <div className={`landing-data-panel-btn p-0 ${ !props.hideEdit ? "move" : "" }`} >
                            <Icon icon="move" size={ 12 } className=""/>
                        </div>  
                    </>
                } 
            </div>
    }
}